"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_tracker_1 = require("@snowplow/browser-tracker");
const minimumVisitLength = 30;
const heartbeatDelay = 10;
/**
 * Enables the Activity Tracking plugin with custom configuration
 */
const enableActivityTrackingWithConfig = () => {
    (0, browser_tracker_1.enableActivityTracking)({
        minimumVisitLength,
        heartbeatDelay,
    });
};
exports.default = enableActivityTrackingWithConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aXZpdHlUcmFja2luZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wbHVnaW5zL2N1c3RvbUVuYWJsZUNvbmZpZ3VyYXRpb25zL2FjdGl2aXR5VHJhY2tpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrREFBbUU7QUFFbkUsTUFBTSxrQkFBa0IsR0FBRyxFQUFFLENBQUM7QUFDOUIsTUFBTSxjQUFjLEdBQUcsRUFBRSxDQUFDO0FBRTFCOztHQUVHO0FBQ0gsTUFBTSxnQ0FBZ0MsR0FBRyxHQUFTLEVBQUU7SUFDaEQsSUFBQSx3Q0FBc0IsRUFBQztRQUNuQixrQkFBa0I7UUFDbEIsY0FBYztLQUNqQixDQUFDLENBQUM7QUFDUCxDQUFDLENBQUM7QUFFRixrQkFBZSxnQ0FBZ0MsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/plugins/customEnableConfigurations/activityTracking.ts